import { Skeleton, cn } from "ui";

type SkeletonCircleProps = {
  /** Diameter in pixels. */
  size?: number;
  className?: string;
};

export const SkeletonCircle = ({
  size = 36,
  className,
}: SkeletonCircleProps) => (
  <Skeleton
    className={cn("rounded-full", className)}
    style={{ width: size, height: size }}
  />
);
